import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { uploadManual, getManuals, manualDelete } from "./modules/actions";

const mapStateToProps = (state) => ({
  state: {
    manuals: state.manualReducer.manuals,
    uploadingType: state.manualReducer.loading,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      uploadManual,
      getManuals,
      manualDelete,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
